<script>
    import NavbarMenu from './navbar_menu.svelte';
    export let colorSent = 'black';
    $: console.log('colorSent', colorSent);
</script>

<div class="main-div">
    <div class="logo-section" on:click={() => (location.href = '/')}>
        {#if colorSent == 'black'}
            <img src="/images/header/logo_blue.svg" alt="" />
        {:else}
            <img src="/images/header/logo_white.svg" alt="" />
        {/if}
    </div>

    <div class="content-section">
        <NavbarMenu navColor = {colorSent}/>
    </div>
</div>

<style>
    .main-div {
        display: flex;
        width: 99vw;
        flex-direction: row;
        height: 5.91vw;
        right: 0;
        top: 3.175vw;
        position: absolute;
        z-index: 1;
        justify-content: space-between;
        gap: 5.046vw;
    }
    .logo-section {
        width: 12.948vw;
        height: 5.91vw;
        margin-left: 5.777vw;
        cursor: pointer;
    }
    .logo-section img {
        width: 100%;
        height: 100%;
    }
    .content-section {
        width: 75.44vw;
        height: 3.254vw;
        border-bottom-left-radius: 2.656vw;
        border-top-left-radius: 2.656vw;
        align-items: center;
        margin: auto;
    }
</style>
